import React, { useEffect, useState } from "react";
import { Input, Form } from "antd";
import { useNavigate } from "react-router";
import AuthStore from "../../../../stores/AuthStore";
import { getParamFromUrlSearch } from "../../../../utils/paramsUtil";
import styles from "./index.module.scss";
import DDlogin from "ddlogin-react";

interface LoginByAccountProps {
  setLoginType: (state: number) => void;
}
const LoginByDingDing: React.FC<LoginByAccountProps> = (props) => {
  const { setLoginType } = props;
  const navigate = useNavigate();
  useEffect(() => {
    window.addEventListener("message", handleMessage, false);

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const qrcodeHost = "https://oapi.dingtalk.com/connect/qrconnect"; // 二维码页面

  const dingdingCofig = {
    appid: "dingj7krchg497lyg6rg",
    redirect_uri:
      window.HOSTS.DD_IP[process.env.NODE_ENV] +
      encodeURIComponent(encodeURIComponent(window.HOSTS.HOST[process.env.NODE_ENV] ?? "")),
  };
  const options = {
    id: "login-container",
    style: "border:none;background-color:#FFFFFF;",
    goto: `${qrcodeHost}?appid=${dingdingCofig.appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${dingdingCofig.redirect_uri}`,
    // width: "290px",
    height: "320px",
  };
  const handleMessage = (event: any) => {
    var origin = event.origin;
    console.log("origin", event.origin);
    if (origin === "https://login.dingtalk.com") {
      //判断是否来自ddLogin扫码事件。
      var loginTmpCode = event.data;
      //获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
      let url = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${dingdingCofig.appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${dingdingCofig.redirect_uri}
            &loginTmpCode=${loginTmpCode}`;
      window.location.href = url;
      console.log("event", event);
    }
  };

  return (
    <div className={styles.auth_form}>
      <div className={styles.title}>
        <div style={{ cursor: "pointer" }} onClick={() => setLoginType(2)}>
          短信登录
        </div>
        <div style={{ cursor: "pointer" }} onClick={() => setLoginType(1)}>
          密码登录
        </div>
        <div style={{ cursor: "pointer", color: "#FFC75D" }}>钉钉扫码</div>
      </div>
      <div className={styles.line}>
        <div className={styles.lineChild}></div>
      </div>
      <DDlogin options={options} className={styles.ddContainer} />
      <div className={styles.ddContainer_fill}></div>
    </div>
  );
};

export default LoginByDingDing;
